module.exports = __webpack_public_path__ + "dojo-toolkit.2egynV9t.png";